import type { ISbStoryData } from '@storyblok/js';
import type { ShopPageGroupStoryblok } from '$types/bloks';
import type { DynamicPage } from '$pages/dynamic-page.svelte';
import type { Region } from '$lib/region';
import { fetchers } from '$lib/shopify';
import { LanguageCode } from '$gql/storefront/schemas';

type ShopPageGroupStory = ISbStoryData<ShopPageGroupStoryblok>;

export type ShopPageGroup = {
  story: ShopPageGroupStory;
  pageSize: number;
  seo: {
    title?: string | null | undefined;
    description?: string | null | undefined;
  };
  title: string | undefined;
};

export const isShopPageGroupStory = (story: DynamicPage['story']): story is ShopPageGroupStory => {
  return story.content.component === 'shop-page-group';
};
export const isShopPageGroup = (data: DynamicPage): data is ShopPageGroup => {
  return data.story.content.component === 'shop-page-group';
};

export const SHOP_PAGE_GROUP_RELATIONS = [] as const;

export const getShopPageGroupData = async ({
  story,
  pageSize,
  region,
  lang
}: {
  story: ShopPageGroupStory;
  pageSize: number;
  region: Region;
  lang: keyof typeof LanguageCode;
}): Promise<ShopPageGroup> => {
  const handle = story.slug;
  const defaultSEO = (
    await fetchers[region].getCollectionSeo({
      handle,
      lang: LanguageCode[lang]
    })
  ).collection;

  return {
    story,
    pageSize,
    seo: {
      title: defaultSEO?.seo.title || defaultSEO?.title,
      description: defaultSEO?.seo.description || defaultSEO?.description
    },
    title: defaultSEO?.title
  };
};
